<template>
    <div class="aboutall">
      <div>
        <div class="tp1">
            <div>
              <b-img :src="require('@/assets/newbanner02.png')" class="tp1-image" />
            </div>  
        </div>
        <div class="tp2">
          <div class="tp2_1">
            <div class="tp2_1_1">
              <b-img :src="require('@/assets/yinhao1.png')" class="tp2-image1" />
            </div>
            <div class="tp2_1_2">
              The Global Situation Of Diabetes Is Increasingly Serious
            </div>
          </div>
        </div>

        <div class="tp3">
          <div class="tp3left"></div>
          <div class="tp3_1">
            <div class="tp3_1_1">
              <div class="tp3_1_1_d">
                At present, diabetes cannot be completely cured, but through proper management, diabetes patients can effectively control the blood sugar level, and the condition can be effectively controlled and alleviated, so as to reduce or delay the occurrence of complications and improve the quality of life.
              </div>
            </div>
            <div class="tp3_1_2">
              <b-img  fluid :src="require('@/assets/yinhao2.png')" class="tp3_1_2-image"></b-img>
            </div>
          </div>
          <div class="tp3right"></div>
        </div>

        <div class="tp4">
          <div>
            <b-img :src="require('@/assets/aboutpic01.png')" class="tp4-image" />
          </div>  
        </div>

        <div class="tp5">
          <div class="tp5_title">Digital Diabetes Management</div>
          <div class="tp5_sub">We Provide Digital Diabetes Management Solutions, Changing The Traditional Way Of Treating Diabetes<br> and Making Diabetes Management Easier.</div>
        </div>

        <div class="tp6">
          <div class="tp7">
            <div class="tp7_1">
              <div class="tp7_1_1">Out-Of-Hospital Scenarios</div>
              <div class="tp7_1_2">On Call Care APP</div>
              <div class="tp7_1_3">On Call Care Platform</div>
              <div class="tp7_1_4">Blood Glucose Meter</div>
            </div>
          </div>
          <div class="tp6_1">
            <b-img :src="require('@/assets/aboutp3.png')" class="tp6-image" />
          </div>
          <div class="tp8">
            <div class="tp8_1">
              <div class="tp8_1_1">In-Hospital Scenarios</div>
              <div class="tp8_1_2">
                <div class="tp8_1_2_1">
                  Hospital-Based Management Platform
                </div>
              </div>
              <div class="tp8_1_3">On Call Smart Pro Analyzer</div>
            </div>
          </div>
        </div>

        <div class="tp9">
          <div class="tp9_title">The Necessity Of Digitalization</div>
          <div class="tp9_sub">Converting Traditional Processes Into Digital Forms, Digitizing Patient Health Records For Easy Access By Doctors,<br> Improving Efficiency, and Enhancing User Experience</div>
        </div>

        <div class="tp10">
          <div class="tp10_left"></div>
          <div class="tp10_mid">
            <div class="tp10_mid_1">
              <div class="tp10_mid_1_image"><b-img :src="require('@/assets/aboutp4.svg')" class="tp10_mid_1_image" /></div>
              <div class="tp10_mid_1_title">Efficient Record-Keeping Methods</div>
              <div class="tp10_mid_1_sub1">
                <div class="tp10_mid_1_sub1_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_1_sub1_d">Change the traditional way patients keep records</div>
              </div>
              <div class="tp10_mid_1_sub2">
                <div class="tp10_mid_1_sub2_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_1_sub2_d">From manual entry or data synchronization from glucometers</div>
              </div>
            </div>
            <div class="tp10_mid_2">
              <div class="tp10_mid_2_image"><b-img :src="require('@/assets/aboutp5.svg')" class="tp10_mid_2_image" /></div>
              <div class="tp10_mid_2_title">Data Sharing</div>
              <div class="tp10_mid_2_sub1">
                <div class="tp10_mid_2_sub1_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_2_sub1_d">Comprehensive medical services and health management</div>
              </div>
              <div class="tp10_mid_2_sub2">
                <div class="tp10_mid_2_sub2_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_2_sub2_d">Enhance the continuity of medical care</div>
              </div>
            </div>
            <div class="tp10_mid_3">
              <div class="tp10_mid_3_image"><b-img :src="require('@/assets/aboutp6.svg')" class="tp10_mid_3_image" /></div>
              <div class="tp10_mid_3_title">Visualized Reports</div>
              <div class="tp10_mid_3_sub1">
                <div class="tp10_mid_3_sub1_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_3_sub1_d">Higher treatment satisfaction</div>
              </div>
              <div class="tp10_mid_3_sub2">
                <div class="tp10_mid_3_sub2_image"><b-img :src="require('@/assets/abouticon.png')" class="icon" /></div>
                <div class="tp10_mid_3_sub2_d">Personalized medical experience</div>
              </div>
            </div>
          </div>
          <div class="tp10_right"></div>
        </div>

        <div class="tp5">
          <div class="tp5_title">People Suitable For Digital Healthcare</div>
          <div class="tp5_sub">Digital Diabetes Management Has Not Only Improved The Treatment Outcomes For Patients But Also Enhanced The Efficiency<br> And Quality Of The Healthcare System.</div>
        </div>

        <div class="tp11">
          <div class="tp11_left"></div>
          <div class="tp11_mid">
            <div class="tp11_mid_left"><b-img :src="require('@/assets/about_tp11.png')" class="tp11-image1" /></div>
            <div class="tp11_mid_right">
              <div class="tp11_mid_right_1">
                <div class="tp11_mid_right_1_title">Patients With Diabetes</div>
                <div class="tp11_mid_right_1_sub">Through digital diabetes management, patients can better monitor blood glucose levels, record their dietary habits and exercise situations, thereby improving their self-management abilities.</div>
              </div>
              <div class="tp11_mid_right_2">
                <div class="tp11_mid_right_2_title">Healthcare Professionals</div>
                <div class="tp11_mid_right_2_sub">Digital diabetes management helps in the rational allocation of medical resources. Through remote monitoring and online consultation, it can reduce the pressure of outpatient services in hospitals and allow patients to receive professional medical advice at home.</div>
              </div>
              <div class="tp11_mid_right_3">
                <div class="tp11_mid_right_3_title">Healthcare System</div>
                <div class="tp11_mid_right_3_sub">Digital diabetes management helps to reduce the number of patient hospitalizations and the occurrence of complications, thereby lowering overall medical costs. It is an important part of medical informatization construction and helps to improve the level of informatization of the entire healthcare system.</div>
              </div>
            </div>
          </div>
          <div class="tp11_right"></div>
        </div>

      </div>      

        
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage'
  }
  </script>
  
  <style scoped>
  .aboutall{
    min-width: 1200px;
  }

  .tp1 {
  position: relative;
    width: 100%;
    overflow: hidden;
  }
  .tp1-image{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .tp2{
    display: flex;
    justify-content: center; /* 水平方向居中 */
    align-items: center; /* 垂直方向居中 */
    background-color: #EEF7FF;
    padding-top: 28px;
  }
  .tp2_1{
    display: flex;
    flex-direction: row; /* 水平方向布局 */
    align-items: center; /* 垂直方向居中 */
  }
  .tp2_1_2{
    font-family: Arial;
    font-size: 32px;
    font-weight: 400;
    line-height: 40px;
    margin-top: 20px;
    margin-left: 22px;
    color: #000000;
  }
  .tp2-image1{
    width: 50px; /* 可根据需要调整图像大小 */
    height: auto;
  }
  .tp3 {
    display: grid;
    grid-template-columns: 1fr 1041px 1fr; /* 左中右三部分 */
    align-items: center; /* 垂直方向居中 */
    background-color:#EEF7FF ;
    padding-top: 40px;
  }

  .tp3left, .tp3right {
    background-color: #f0f0f0; /* 可选：设置背景颜色以便调试 */
  }
  .tp3_1 {
    align-items: center; /* 垂直方向居中 */
    justify-content: center; /* 水平方向居中 */
  }

  .tp3_1_1 {
    flex: 0 0 1040px; /* 文本部分固定占用1041像素 */
    margin-right: 10px; /* 可选：调整文本和图像之间的间距 */
  }
  .tp3_1_1_d{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 26px;
color: #555555;

  }
  .tp3_1_2 {
    flex: 1; /* 图像部分占用剩余空间 */
    text-align: right;
  }

  .tp3_1_2-image {
    width: 50px; /* 可根据需要调整图像大小 */
    height: auto;
    align-items: left;
  }
  .tp4 {
    text-align: center;
    background-color: #EEF7FF;
    padding-top: 16px;
  }

  .tp4-image {
    width: 51.67%; /* 800 / 1920 = 0.4167, 转换为视口宽度的百分比 */
    height: auto; /* 自动调整高度以保持比例 */
  }
  .tp5{
    text-align: center;
    margin-top: 67px;
  }
  .tp5_title{
    font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #000;
  }
  .tp5_sub{
    font-family: Arial;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1B2944;
    margin-top: 16px;
  }
  .tp6 {
    display: grid;
    align-items: center; /* 垂直方向居中 */
    position: relative; /* 使子元素可以绝对定位 */
  }

  .tp7, .tp8 {
    display: flex;
    flex-direction: column;
    justify-content: center; /* 垂直方向居中 */
    gap: 1.85vh; /* 每个文本块之间的间距（相对于视口高度） */
    position: absolute; /* 绝对定位 */
    top: 50%;
    transform: translateY(-50%); /* 垂直居中 */
  }

  .tp7 {
    left: calc(50% - 960px + 391px); /* 水平居中并向右偏移391px */
    margin-top: 88px;
  }

  .tp8 {
    right: calc(50% - 960px + 391px); /* 水平居中并向左偏移391px */
    margin-top: 76px;
  }

  .tp7_1_1, .tp7_1_2, .tp7_1_3, .tp7_1_4,
  .tp8_1_1, .tp8_1_2, .tp8_1_3{
    width: 12.5vw; /* 240 / 1920 = 0.125，转换为视口宽度的百分比 */
    height: 4.63vh; /* 50 / 1080 = 0.0463，转换为视口高度的百分比 */
    background-color:#F3F8FE ;
    display: flex;
    align-items: center; /* 垂直方向居中 */
    justify-content: center; /* 水平方向居中 */
    margin-bottom: 16px;
    border-radius: 8px;
    color: #000000;
    font-family: Inter;
font-size: 16px;
font-weight: 400;
line-height: 34px;
text-align: center;
  }
  .tp8_1_1, .tp8_1_2{
    margin-bottom: 32px;
  }
  .tp7_1_1,.tp8_1_1{
    background-color:#007EFF;
    color: #FFFFFF;
  }
  .tp8_1_2{
    height: 5.63vh;
  }
  .tp8_1_2_1{
    width: 186px;
    text-align: center;
  }
  .tp6_1 {
    display: flex;
    justify-content: center; /* 水平方向居中 */
    position: relative; /* 使子元素可以绝对定位 */
    z-index: -1; /* 确保图片在文字的下方 */
  }

  .tp6-image {
    max-width: 100%;
    height: auto;
  }

  .tp9{
    text-align: center;
    margin-top: 67px;
  }
  .tp9_title{
    font-family: Arial;
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #000;
  }
  .tp9_sub{
    font-family: Arial;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1B2944;
    margin-top: 16px;
    margin-bottom: 56px;
  }

  .tp10 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */

}

.tp10_left,
.tp10_right {

}

.tp10_mid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 将中间部分均等划分为三列 */
  gap: 20px; /* 设置每列之间的间距 */
}

.tp10_mid_1,
.tp10_mid_2,
.tp10_mid_3 {

  padding: 20px; /* 添加内边距 */
  display: flex;
  flex-direction: column;
  align-items: center; /* 子元素在垂直方向上居中 */
  justify-content: flex-start; /* 子元素在水平方向上对齐起始位置 */
  gap: 10px; /* 子元素之间的间距 */
}

.tp10_mid_image {
  display: flex;
  justify-content: center; /* 水平方向居中 */
  align-items: center; /* 垂直方向居中 */
  width: 100%; /* 确保容器宽度为100% */
}

.tp10_mid_sub {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 子元素在水平方向上靠左对齐 */
  width: 100%; /* 确保容器宽度为100% */
}

.tp10_mid_1_image,
.tp10_mid_2_image,
.tp10_mid_3_image {
  width: 100px; /* 图像宽度 */
  height: auto;
}

.icon {
  width: 6px; /* 图标宽度 */
  height: auto;
}

.tp10_mid_1_title,
.tp10_mid_2_title,
.tp10_mid_3_title {
  font-family: Arial;
font-size: 20px;
font-weight: 700;
line-height: 28px;
  text-align: center;
  color: #333333;
}

.tp10_mid_1_sub1,
.tp10_mid_1_sub2,
.tp10_mid_2_sub1,
.tp10_mid_2_sub2,
.tp10_mid_3_sub1,
.tp10_mid_3_sub2 {
  display: flex;
  align-items: flex-start;
  gap: 10px; /* 子元素之间的间距 */
  width: 100%; /* 确保容器宽度为100% */
}
.tp10_mid_3_sub1,
.tp10_mid_3_sub2{
  margin-left: 72px;
}

.tp10_mid_1_sub1_d,
.tp10_mid_1_sub2_d,
.tp10_mid_2_sub1_d,
.tp10_mid_2_sub2_d,
.tp10_mid_3_sub1_d,
.tp10_mid_3_sub2_d {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
color: #666666;
}


.tp11 {
  display: grid;
  grid-template-columns: 1fr 1200px 1fr; /* 定义三列：左、中、右 */
  gap: 0; /* 去掉列间距 */
margin-top: 40px;
margin-bottom: 64px;
}

.tp11_mid {
  display: grid;
  grid-template-columns: 700px 500px; /* 将中间部分划分为两列，左边700px，右边500px */
  gap: 0; /* 去掉列间距 */
  align-items: center; /* 子元素在垂直方向上居中对齐 */
}

.tp11_mid_left {
  display: flex;
  align-items: center;
  justify-content: center;

}

.tp11-image1 {
  margin-right: 40px;
  width: 100%; /* 图像宽度 */
  height: auto; /* 图像高度 */
}

.tp11_mid_right {
  padding: 20px; /* 添加内边距 */
}

.tp11_mid_right_1,
.tp11_mid_right_2 {
  margin-bottom: 20px; /* 每个块之间的间距 */
}

.tp11_mid_right_1_title,
.tp11_mid_right_2_title,
.tp11_mid_right_3_title {
  font-family: Arial;
font-size: 20px;
font-weight: 700;
line-height: 28px;
text-align: left;
color: #333333;
margin-bottom: 8px;
}

.tp11_mid_right_1_sub,
.tp11_mid_right_2_sub,
.tp11_mid_right_3_sub {
  font-family: Arial;
font-size: 16px;
font-weight: 400;
line-height: 24px;
text-align: left;

color: #555555;
}
.tp11_mid_right_1_sub,
.tp11_mid_right_2_sub {
  margin-bottom: 24px;
}
  </style>